import styled from "styled-components";

import { OpenInNew } from "@similarweb/icons";
import { setFontVariant, colorsPalettes, setElevation } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledLink = styled.span`
    cursor: pointer;
    ${setFontVariant("body2", colorsPalettes.blue[400])};
`;

export const SuggestionIcon = styled(OpenInNew)`
    position: absolute;
    top: 6px;
    right: 6px;
`;

export const Suggestion = styled(Flex)`
    padding: 12px;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    transition: all ease-out 200ms;

    ${SuggestionIcon} {
        display: none;
    }

    &:hover {
        ${setElevation("Z1")};

        ${SuggestionIcon} {
            display: block;
        }
    }
`;
